module.exports = __webpack_public_path__ + "static/media/PM31.7dac8892.png";